import { Badge } from './Badge';

type Status =
  | 'draft'
  | 'submitted'
  | 'approved'
  | 'rejected'
  | 'withdrawn'
  | 'paid'
  | 'void'
  | 'declared'
  | 'settled'
  | 'disputed';

interface StatusChipProps {
  status: Status;
  className?: string;
}

const statusConfig: Record<Status, { label: string; tone: 'neutral' | 'success' | 'warning' | 'danger' | 'info' }> = {
  draft: { label: 'Draft', tone: 'neutral' },
  submitted: { label: 'Submitted', tone: 'info' },
  approved: { label: 'Approved', tone: 'success' },
  rejected: { label: 'Rejected', tone: 'danger' },
  withdrawn: { label: 'Taken back', tone: 'neutral' },
  paid: { label: 'Paid', tone: 'success' },
  void: { label: 'Void', tone: 'danger' },
  declared: { label: 'Declared', tone: 'info' },
  settled: { label: 'Settled', tone: 'success' },
  disputed: { label: 'Disputed', tone: 'warning' },
};

export const StatusChip = ({ status, className }: StatusChipProps) => {
  const config = statusConfig[status];
  return (
    <Badge tone={config.tone} className={className}>
      {config.label}
    </Badge>
  );
};
